import {
    BarChartOutlined,
    BgColorsOutlined,
    DatabaseOutlined,
    FilterOutlined,
    LogoutOutlined,
    SettingOutlined,
    SlidersOutlined,
    TeamOutlined
} from '@ant-design/icons'
import React from 'react'

import {ManagerBean} from 'api/base/api.ts'

import {routes} from 'utils/routes'
import ManagerRoleEnum = ManagerBean.ManagerRoleEnum;

export interface Item {
    role?: ManagerRoleEnum
    name: string
    to?: string
    image?: React.ReactNode
    spacing?: boolean
    items?: Array<Item>
}

export const navBarItems: Item[] = [
    {name: 'Dashboard', to: routes.dashboard.root, image: <BarChartOutlined/>},
    {name: 'Publishers', to: routes.publisher.root, image: <TeamOutlined/>},
    {name: 'Statistics', to: routes.statistics.root, image: <DatabaseOutlined/>},
    {name: 'Spacing-1', spacing: true},
    {role: ManagerRoleEnum.PRIMARY, name: 'Users', to: routes.user.root, image: <TeamOutlined/>},
    {
        role: ManagerRoleEnum.PRIMARY, name: 'Settings', image: <SettingOutlined/>, items: [
            {
                role: ManagerRoleEnum.PRIMARY,
                name: 'Customization',
                to: routes.settings.root,
                image: <BgColorsOutlined/>
            },
            {
                role: ManagerRoleEnum.PRIMARY,
                name: 'Custom Filters',
                to: routes.customFilter.root,
                image: <FilterOutlined/>
            },
            {role: ManagerRoleEnum.PRIMARY, name: 'Preferences', to: routes.preferences.root, image: <SlidersOutlined/>}
        ]
    },
    {name: 'Logout', to: routes.logout.root, image: <LogoutOutlined/>},
]
